import { ZCoreUserGroupMember } from '../types';
import { EntityService } from './EntityService';

export class ZCoreUserGroupMemberService extends EntityService<ZCoreUserGroupMember> {
    //protected childrenEntities = ['App03PortfolioUsers($expand=User)'];

    constructor() {
        super(`/ZCoreUserGroupMembers`);
    }

}